import {Crown} from "@phosphor-icons/react";

const wrapCls = "flex items-center justify-between gap-4 mb-4";
const titleRowCls = "flex items-center gap-2";
const iconCls = "text-[var(--color-primary)] shrink-0";
const titleCls = "m-0 font-[var(--font-family-display)] font-bold text-xl text-[var(--color-primary)]";
const counterCls =
  "shrink-0 text-xs font-medium text-[var(--color-text-tertiary)] " +
  "bg-[var(--color-surface-2)] border border-[var(--color-border)] " +
  "px-3 py-1 rounded-full tabular-nums whitespace-nowrap";

interface CatalogHeaderProps {
  totalCount: number;
  showingCount: number;
}

const CatalogHeader = ({totalCount, showingCount}: CatalogHeaderProps) => (
  <div className={wrapCls}>
    <div className={titleRowCls}>
      <Crown
        size={18}
        weight="fill"
        className={iconCls}
        aria-hidden="true"
      />
      <h2 className={titleCls}>Todos los juegos</h2>
    </div>
    <p
      className={counterCls}
      aria-live="polite"
      aria-atomic="true"
    >
      {showingCount} de {totalCount}
    </p>
  </div>
);

export default CatalogHeader;
